import { render, staticRenderFns } from "./CreateTeamView.vue?vue&type=template&id=824e32b4&scoped=true"
import script from "./CreateTeamView.vue?vue&type=script&lang=js"
export * from "./CreateTeamView.vue?vue&type=script&lang=js"
import style0 from "./CreateTeamView.vue?vue&type=style&index=0&id=824e32b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824e32b4",
  null
  
)

export default component.exports